import { PromiseResponse } from '@types';

import {
  Autocomplete,
  DomainTables,
  GeneratePDFResponse,
  GuideSADT,
  HiredSolicitantCodeEntry,
  HiredSolicitantSlug,
  PatchGuideSADTPayload,
} from 'features/tissInvoicing/types';
import { apiTissInvoicing } from '..';

export function getGuideData(eventId: string): PromiseResponse<GuideSADT> {
  return apiTissInvoicing(`/event/${eventId}/guide/`);
}

export function getDomainTables(): PromiseResponse<DomainTables> {
  return apiTissInvoicing(`/domains/`);
}

export function getAutocompleteOptions(
  eventId: string,
): PromiseResponse<Omit<Autocomplete, 'hired_solicitants'>> {
  return apiTissInvoicing(`/event/${eventId}/autocomplete/`);
}

export function getHiredSolicitantData(
  eventId: string,
  solicitantId: number,
  type: HiredSolicitantSlug,
): PromiseResponse<HiredSolicitantCodeEntry> {
  return apiTissInvoicing(`/event/${eventId}/${type}/${solicitantId}`);
}

export function patchGuideSADT(
  guideId: string,
  payload: PatchGuideSADTPayload,
): PromiseResponse<GuideSADT> {
  return apiTissInvoicing.patch(`/guide/${guideId}/`, payload);
}

export const getGuidePDFUrl = (
  eventId: string,
): PromiseResponse<GeneratePDFResponse> =>
  apiTissInvoicing.get(`/guide/event/${eventId}/pdf`);
